import React from 'react';
import { IconMapPin } from '../../assets/icons/IconMapPin';

interface CoordinatesBadgeProps {
    coordinates: string;
}

export const CoordinatesBadge: React.FC<CoordinatesBadgeProps> = ({ coordinates }) => (
    <p data-testid="followup-recap-coordinates" className="flex items-start gap-s self-start px-m py-m rounded-lg bg-surface-secondary text-xs font-medium text-content">
        <IconMapPin data-testid="followup-recap-coordinates-icon" className="shrink-0 mt-px" />
        <span className="min-w-0">{coordinates}</span>
    </p>
);
